// These are the available Nora experiences.
// Variants line up with a deployed Nora environment: https://docs.google.com/document/d/1ZDhM-66jd1_535OGypCQT4Vae9hhiwvwvpCNR71glt0/edit?tab=t.0#heading=h.7jfx6giwa1nj

export const MULTI_TOOL = 'multi-tool';
export const CORPUS_QA = 'corpus-qa';
export const PAPER_FINDER = 'paper-finder';
export const TABLE_ANNOTATION = 'table-annotation';
export const DATAVOYAGER = 'datavoyager';
export const DEFAULT_VARIANT = MULTI_TOOL;
